import { z } from "zod";

// Strong password validation schema
export const passwordSchema = z.string()
  .min(12, "Password must be at least 12 characters")
  .max(128, "Password too long")
  .regex(/[A-Z]/, "Must contain at least one uppercase letter")
  .regex(/[a-z]/, "Must contain at least one lowercase letter")
  .regex(/[0-9]/, "Must contain at least one number")
  .regex(/[^A-Za-z0-9]/, "Must contain at least one special character");

// Email validation schema
export const emailSchema = z.string()
  .email("Invalid email address")
  .max(255, "Email too long");

// Authentication schemas
export const authSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export const signupSchema = authSchema.extend({
  confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"],
});

// Admin settings validation
export const adminSettingsSchema = z.object({
  force_last_number: z.number().int().nullable(),
  ending_digits: z.string().regex(/^\d+(,\d+)*$/, "Must be comma-separated digits").max(50).nullable(),
});

// Queued number validation
export const queuedNumberSchema = z.object({
  number: z.number().int(),
  min_range: z.number().int(),
  max_range: z.number().int(),
  session_id: z.string().uuid().nullable().optional(),
}).refine((data) => data.min_range < data.max_range, {
  message: "Min range must be less than max range",
}).refine((data) => data.number >= data.min_range && data.number <= data.max_range, {
  message: "Number must be within the specified range",
});

// Number generation validation
export const generateNumbersSchema = z.object({
  min: z.number().int().min(-999999999),
  max: z.number().int().max(999999999),
  count: z.number().int().min(1).max(1000),
  usedNumbers: z.array(z.number().int()).optional().default([]),
  sessionId: z.string().uuid().nullable().optional(),
}).refine((data) => data.min < data.max, {
  message: "Min must be less than max",
});
